import React, { useEffect, useState } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import "../../styles/privacypolicy.css"
import url from '../url/url'

function Terms() {
    const { t, i18n } = useTranslation(['legal', 'common'])
    const [sectionArray, setSectionArray] = useState(t('legal:termsContent') || '')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const title = t("legal:termsMetaTitle") || "Terms and Conditions | BeforeVault";
        const description = t("legal:termsMetaDescription");
        document.title = title;
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc && description) metaDesc.setAttribute('content', description);
        document.documentElement.lang = i18n.language || 'en';
    }, [t, i18n.language]);

    useEffect(() => {
        const fetchContent = async () => {
            const currentLang = i18n.language || 'en';
            setSectionArray(t('legal:termsContent') || '');

            if (currentLang === 'en' || currentLang.startsWith('en')) {
                setLoading(true);
                try {
                    const InsertAPIURL = `${url}api/v1/websiteTerms/getTerms?type=TERMS_AND_CONDITIONS`;
                    const response = await fetch(InsertAPIURL, {
                        method: 'GET',
                        headers: { Accept: 'application/json' },
                    });
                    const data = await response.json();
                    if (data && data.success && data.result && data.result[0] && data.result[0].details) {
                        const cleanDetails = data.result[0].details
                            .replace(/color:\s*(#[0-9a-fA-F]{3,6}|rgb\([^)]+\)|rgba\([^)]+\));?/gi, '')
                            .replace(/background-color:\s*(#[0-9a-fA-F]{3,6}|rgb\([^)]+\)|rgba\([^)]+\));?/gi, '');
                        setSectionArray(cleanDetails);
                    }
                } catch (err) {
                    setSectionArray(t('legal:termsContent') || '');
                } finally {
                    setLoading(false);
                }
            } else {
                setSectionArray(t('legal:termsContent') || '');
                setLoading(false);
            }
        };

        fetchContent();
    }, [t, i18n.language]);

    return (
        <Box className="privacy" sx={{ overflow: "hidden", py: { xs: 2, md: 4 }, px: { xs: 1.5, sm: 2.5, md: 4 } }}>
            <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} md={12}>
                    <Typography
                        variant="h3"
                        sx={{
                            color: '#02B096',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            mb: 2.5,
                            fontSize: { xs: '1.4rem', sm: '1.8rem', md: '2.2rem' }
                        }}
                    >
                        {t('legal:termsAndConditions')}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
                            <Typography color="gray">{t('common:buttons.loading') || 'Loading...'}</Typography>
                        </Box>
                    ) : (
                        <Typography
                            variant="body1"
                            component="div"
                            sx={{
                                color: 'var(--bv-ink-60, #475569)',
                                textAlign: 'left',
                                lineHeight: 1.75,
                                fontSize: { xs: '0.92rem', sm: '0.98rem', md: '1.02rem' },
                                wordBreak: 'break-word',
                                '& *': { color: 'inherit' },
                                '& h2': { color: 'var(--bv-teal, #02B096)', mt: 2.5, mb: 1, fontSize: { xs: '1.25rem', sm: '1.45rem', md: '1.65rem' }, lineHeight: 1.3, fontWeight: 700 },
                                '& h3, & h4, & h5, & h6': { color: 'var(--bv-ink, #1e293b)', mt: 2.5, mb: 1, fontSize: { xs: '1.05rem', sm: '1.15rem', md: '1.25rem' }, lineHeight: 1.35, fontWeight: 700 },
                                '& strong, & b, & [style*="Heavy"], & [style*="bold"], & [style*="Bold"], & span[style*="Heavy"], & span[style*="bold"]': { color: 'var(--bv-ink, #1e293b) !important', fontWeight: 700 },
                                '& ul': { pl: { xs: 2.5, sm: 3.5 }, mb: 2 },
                                '& li': { mb: 0.8, color: 'var(--bv-ink-60, #475569)' },
                                '& p, & span, & div': { mb: 1.6, color: 'var(--bv-ink-60, #475569)' },
                                '& a, & a *': { color: 'var(--bv-teal, #02B096) !important', fontWeight: 600 }
                            }}
                            dangerouslySetInnerHTML={{ __html: sectionArray }}
                        />
                    )}
                </Grid>
            </Grid>
        </Box>
    );
}

export default Terms;
